module.exports = import("https://doir.prod.uw2.gke.gcp.albertsons.com/doir-groc-ui/remoteEntry.js");;